var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#F39C12",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5455 43.4546H41.8182C38.2092 43.4546 35.2729 40.5183 35.2729 36.9093C35.2729 33.3002 38.2092 30.364 41.8182 30.364H47.5455C47.9977 30.364 48.3636 29.998 48.3636 29.5458V27.0913C48.3636 25.3756 47.0328 23.9802 45.3514 23.8449L40.6526 15.6377C40.2171 14.8786 39.514 14.3361 38.6726 14.1108C37.8353 13.8871 36.9596 14.0046 36.2102 14.4408L20.1022 23.8186H17.2732C15.4683 23.8186 14.0005 25.2863 14.0005 27.0913V46.7273C14.0005 48.5322 15.4682 50 17.2732 50H45.0909C46.8959 50 48.3636 48.5323 48.3636 46.7273V44.2728C48.3636 43.8206 47.9977 43.4546 47.5455 43.4546ZM41.6673 20.7047L43.45 23.8186H36.3188L41.6673 20.7047ZM23.3545 23.8186L37.0339 15.855C37.4038 15.6385 37.836 15.5809 38.2492 15.6912C38.667 15.8031 39.0154 16.0731 39.232 16.451L39.2337 16.454L26.5845 23.8186H23.3545Z",
    fill: "#F39C12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5454 32.0005H41.8182C39.1112 32.0005 36.9092 34.2025 36.9092 36.9095C36.9092 39.6165 39.1112 41.8185 41.8182 41.8185H47.5454C48.8989 41.8185 49.9999 40.7175 49.9999 39.364V34.455C49.9999 33.1015 48.8989 32.0005 47.5454 32.0005ZM41.8182 38.5458C40.9162 38.5458 40.1819 37.8115 40.1819 36.9095C40.1819 36.0075 40.9162 35.2732 41.8182 35.2732C42.7202 35.2732 43.4545 36.0075 43.4545 36.9095C43.4546 37.8115 42.7203 38.5458 41.8182 38.5458Z",
    fill: "#F39C12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.93f3b8423eddcb9803596c74ba4ef32d.svg";
export { ForwardRef as ReactComponent };